import { render } from "./ListeJournalConnexion.vue?vue&type=template&id=37835e2e&ts=true"
import script from "./ListeJournalConnexion.vue?vue&type=script&lang=ts"
export * from "./ListeJournalConnexion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__